// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { R400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { Flex } from '@atlassian/eoc-flex';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled(Flex)({
	marginTop: token('space.100', '8px'),
	fontFamily: token('font.family.body'),
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Required = styled.span({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:before': {
		content: "'*'",
		marginLeft: token('space.025', '2px'),
		color: token('color.text.danger', R400),
	},
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HintContainer = styled.span({
	marginLeft: token('space.025', '2px'),
});
